import styled from 'styled-components';

// scrollbar-gutter here DOES NOT WORK on SAFARI
const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-gutter: stable both-edges;
  ${({ $isScheduleMessage }) => ($isScheduleMessage ? 'padding: 0;' : 'padding-right: 20px;')}
  max-height: 216px;
  line-height: 1.5;
`;

const ImagePreview = styled.div`
  margin-top: 8px;

  & .rfu-image-previewer {
    flex: none;
    margin: 0;
  }

  & .rfu-image-previewer__image {
    margin-right: 8px;
    margin-bottom: 8px;
  }

  & .rfu-image-upload-button {
    margin-right: 8px;
    margin-bottom: 8px;
  }
`;

const AttachmentPreview = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;

  & .rfu-file-previewer {
    flex: none;
    margin: 0;
  }
`;

export {
  Container,
  ImagePreview,
  AttachmentPreview,
};
